import { HStack, VStack } from '@chakra-ui/react';

import Button from 'components/Button';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { ERoute, IModal } from 'types/frontend';

interface IUnlockFigmaModalProps extends IModal {
  isDownloading: boolean;
  onDownload: () => void;
}

export const UnlockFigmaModal = ({
  isOpen,
  onClose,
}: IUnlockFigmaModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={
        <HStack>
          <Icon type="FigmaLogo" size={40} />
          <Text fontSize="xLarge" fontWeight="semibold">
            Download Figma Design
          </Text>
        </HStack>
      }
      footer={
        <>
          <Button scheme="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            leftIcon={<Icon type="Rocket" />}
            scheme="gradient"
            to={ERoute.Plans}
            autoFocus
          >
            Upgrade to BIG
          </Button>
        </>
      }
    >
      <VStack align={'start'}>
        <Text fontWeight="semibold">Figma designs are a BIG feature.</Text>
        <Text mt={2}>
          As a BIG member, you get access to all Figma design files for pixel-perfect development.
        </Text>
      </VStack>
    </Modal>
  );
};
